<template>
  <div>
    <el-dialog
      :title="platFormTitle"
      :visible.sync="dialogFormVisible"
      width="60%"
      class="dialog"
      center
    >
      <div class="contents1">
        <el-form
          :model="platForm"
          :rules="rules"
          ref="platForm"
          label-width="auto"
        >
          <el-form-item label="上传文件" prop="file">
            <el-upload
              ref="upload"
              :action="`${BASE.PRO1}/tdc/owner/member/addBatch`"
              :headers="{ token: token }"
              name="file"
              :auto-upload="false"
              :file-list="fileList"
              accept=".xlsx,.xls"
              :on-exceed="onExceed"
              :on-change="onChange"
              :before-remove="beforeRemove"
              :on-success="successFile"
              :on-error="errorFile"
              :multiple="false"
              :limit="1"
              class="upload-demo"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-button size="small" type="primary" @click="onDownloadTemplate"
            >下载模版</el-button
          >
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer center-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFrom" :loading="submitLoading"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { BASE } from "@/api";

export default {
  name: "batchAddDialog",
  data() {
    return {
      dialogFormVisible: false,
      platFormTitle: "批量新增补吨专区用户",
      submitLoading: false,
      fileList: [],
      platForm: {
        file: "",
      },
      BASE,
      token: sessionStorage.getItem("token"),
      rules: {
        file: [{ required: true, message: "请上传文件", trigger: "change" }],
      },
    };
  },
  methods: {
    addBatchData() {
      this.dialogFormVisible = true;
      this.fileList = [];
      this.platForm.file = "";
      this.submitLoading = false;
      this.$nextTick(() => {
        if (this.$refs.upload) {
          this.$refs.upload.clearFiles();
        }
        if (this.$refs.platForm) {
          this.$refs.platForm.clearValidate();
        }
      });
    },
    onDownloadTemplate() {
      window.open(
        "https://jiunong-purchase.oss-cn-beijing.aliyuncs.com/general/public/批量新增补吨专区用户模版.xlsx"
      );
    },
    onExceed() {
      this.$message.warning("抱歉，最多只能上传1份文件");
    },
    beforeRemove() {
      this.fileList = [];
      this.platForm.file = "";
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    onChange(file, fileList) {
      this.fileList = fileList ? fileList.slice(-1) : [];
      this.platForm.file = file && file.name ? file.name : "";
      if (this.$refs.platForm) {
        this.$refs.platForm.validateField("file");
      }
    },
    successFile(e) {
      this.submitLoading = false;
      if (e && e.code === 20000) {
        this.dialogFormVisible = false;
        this.$message({
          type: "success",
          message: "导入成功",
        });
        this.$emit("submit-form");
      } else {
        const msg = (e && e.msg) || "导入失败";
        if (this.tool && this.tool.message) {
          this.tool.message(msg, "error");
        } else {
          this.$message.error(msg);
        }
      }
    },
    errorFile() {
      this.submitLoading = false;
      this.$message.error("上传失败");
    },
    submitFrom: debounce(function () {
      if (!this.fileList.length) {
        if (this.tool && this.tool.message) {
          this.tool.message("请上传文件", "error");
        } else {
          this.$message.error("请上传文件");
        }
        return;
      }
      this.$refs.platForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitLoading = true;
        if (this.$refs.upload) {
          this.$refs.upload.submit();
        }
      });
    }, 300),
  },
};
</script>

<style scoped lang="scss">
.dialog {
  padding: 20px;
}

.contents1 {
  box-sizing: border-box;
  padding: 10px 26px 40px;
}

.center-footer {
  text-align: center;
}
</style>
